import { PROJECTS, ONGOING } from "../data/portfolio";
import AboutOutput from "../components/outputs/AboutOutput";
import StackOutput from "../components/outputs/StackOutput";
import ExperienceOutput from "../components/outputs/ExperienceOutput";
import ContactOutput from "../components/outputs/ContactOutput";
import ReadmeOutput from "../components/outputs/ReadmeOutput";

export const ROOT = "~";
export const PROJECTS_DIR = "~/projects";
export const ONGOING_DIR = "~/ongoing";

const ROOT_ENTRIES = [
  { name: "about.txt", type: "file" },
  { name: "stack.json", type: "file" },
  { name: "experience.log", type: "file" },
  { name: "projects/", type: "dir" },
  { name: "ongoing/", type: "dir" },
  { name: "contact.sh", type: "file" },
];

/** Human-readable path shown by `pwd`, e.g. /Users/guest/projects */
export function pwdPath(cwd, user) {
  const base = `/Users/${user}`;
  if (cwd === ROOT) return base;
  return `${base}/${cwd.replace("~/", "")}`;
}

export function lsEntries(cwd) {
  if (cwd === ROOT) return ROOT_ENTRIES;
  if (cwd === PROJECTS_DIR) return PROJECTS.map((p) => ({ name: `${p.slug}.md`, type: "file" }));
  if (cwd === ONGOING_DIR) return ONGOING.map((p) => ({ name: `${p.slug}.md`, type: "file" }));
  return ROOT_ENTRIES;
}

export function resolveCd(cwd, target) {
  if (!target || target === "~") return { ok: true, cwd: ROOT };
  if (target === "..") {
    if (cwd === ROOT) return { ok: true, cwd: ROOT, note: "already at ~" };
    return { ok: true, cwd: ROOT };
  }
  const clean = target.replace(/\/$/, "");
  if (clean === "projects") {
    if (cwd !== ROOT) return { ok: false, error: `cd: no such directory: ${target}` };
    return { ok: true, cwd: PROJECTS_DIR };
  }
  if (clean === "ongoing") {
    if (cwd !== ROOT) return { ok: false, error: `cd: no such directory: ${target}` };
    return { ok: true, cwd: ONGOING_DIR };
  }
  return { ok: false, error: `cd: no such file or directory: ${target}` };
}

export function resolveCat(cwd, filename) {
  if (!filename) return { ok: false, error: "cat: missing file operand" };
  const clean = filename.replace(/\.(txt|json|log|sh|md)$/, "");

  if (cwd === ROOT) {
    if (clean === "about") return { ok: true, node: <AboutOutput /> };
    if (clean === "stack") return { ok: true, node: <StackOutput /> };
    if (clean === "experience") return { ok: true, node: <ExperienceOutput /> };
    if (clean === "contact") return { ok: true, node: <ContactOutput /> };
    if (clean === "projects" || clean === "ongoing") {
      return { ok: false, error: `cat: ${filename}: is a directory` };
    }
    return { ok: false, error: `cat: ${filename}: no such file or directory` };
  }

  if (cwd === PROJECTS_DIR) {
    const item = PROJECTS.find((p) => p.slug === clean);
    if (item) return { ok: true, node: <ReadmeOutput item={item} /> };
    return { ok: false, error: `cat: ${filename}: no such file or directory` };
  }

  if (cwd === ONGOING_DIR) {
    const item = ONGOING.find((p) => p.slug === clean);
    if (item) return { ok: true, node: <ReadmeOutput item={item} /> };
    return { ok: false, error: `cat: ${filename}: no such file or directory` };
  }

  return { ok: false, error: `cat: ${filename}: no such file or directory` };
}